<template>
  <section class="inner-section business-section">
    <div class="inner-heading">
      <h2>业务特性 <small>/business</small></h2>
    </div>
    <div class="feature-grid">
      <article v-for="item in cardList" :key="item.name" class="feature-card">
        <img class="feature-icon" :src="item.imgSrc" :alt="item.name" />
        <h3>{{ item.name }}</h3>
        <p>{{ item.info }}</p>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "MallBusiness",
  data() {
    return {
      cardList: [
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-01.png"), name: "源头直采", info: "坚守源头 严格优选" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-02.png"), name: "品类丰富", info: "近万种商品 一站式购买" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-03.png"), name: "新鲜低价", info: "新鲜品质 每天节省36%" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-04.png"), name: "食品安全", info: "严格管控 天然健康" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-05.png"), name: "每日资讯", info: "餐饮生意经 助您开店赚钱" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-06.png"), name: "闪速下单", info: "常用清单 快速购买" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-07.png"), name: "送货上门", info: "专职配送 准时送达" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-08.png"), name: "买的安心", info: "支持支付宝、微信、到付" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-09.png"), name: "采买顾问", info: "专属销售 一对一服务" },
        { imgSrc: require("@/assets/images/new-img/malls/business-icon-10.png"), name: "售后服务", info: "专业客服 解疑答惑" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.inner-section {
  box-sizing: border-box;
  padding: 52px clamp(28px, 7vw, 112px) 66px;
  background: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.inner-heading {
  margin-bottom: 38px;
}

h2 {
  margin: 0;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: clamp(40px, 4.5vw, 68px);
  font-weight: 650;
  letter-spacing: -0.065em;
  line-height: 1.08;
}

h2 small {
  color: #727b87;
  font-size: 0.42em;
  font-weight: 400;
  letter-spacing: 0;
}

.feature-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, 1fr);
}

.feature-card {
  box-sizing: border-box;
  min-height: 170px;
  padding: 20px 12px;
  text-align: center;
}

.feature-icon {
  display: block;
  width: 55px;
  height: 55px;
  margin: 0 auto 22px;
  object-fit: contain;
}

h3 {
  margin: 0 0 8px;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 17px;
  font-weight: 500;
}

p {
  margin: 0;
  color: #727b87;
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 720px) {
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
